/**
 * Created by Languagenut on 15/04/2019.
 */

import React  from 'react';
import $ from "jquery"

export default class FavoriteButton extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            toggle:this.props.toggle,
        };
    }

    componentWillUnmount(){

    }

    componentDidMount(){

    }

    onClick(){
        if (this.props.stopToggle != true){
            this.setState({
                toggle:!this.state.toggle,
            })
        }
    }

    render(){
        return <div onClick={this.onClick.bind(this)} class={!this.state.toggle ? "no-active" : "active-star"}>
            <span className="fa fa-heart"></span>

        </div>
    }
}